/**
 * @generated SignedSource<<6eaf8968ecb4b3e8efb844fe65892402>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type desktopRecorderApiResumeLocalRecordingMutation$variables = {
  meetingRecordingId: string;
};
export type desktopRecorderApiResumeLocalRecordingMutation$data = {
  readonly confirmClientSideRecordingDidResume: {
    readonly ok: boolean;
  } | null;
};
export type desktopRecorderApiResumeLocalRecordingMutation = {
  response: desktopRecorderApiResumeLocalRecordingMutation$data;
  variables: desktopRecorderApiResumeLocalRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "ConfirmClientSideRecordingDidResume",
    "kind": "LinkedField",
    "name": "confirmClientSideRecordingDidResume",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiResumeLocalRecordingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "desktopRecorderApiResumeLocalRecordingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9782a56213cb7a140b8f2e1238499a0",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiResumeLocalRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation desktopRecorderApiResumeLocalRecordingMutation(\n  $meetingRecordingId: ID!\n) {\n  confirmClientSideRecordingDidResume(meetingRecordingId: $meetingRecordingId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "440387742148e2dd367e77c2e2f1d60b";

export default node;
